import React from 'react';
import { createStyles, makeStyles, Box, Paper } from '@material-ui/core';
import { ExtendedTheme, Radio } from 'neon-design-system';

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	root: {
		border: `1px solid ${theme.themeColors.grey[600]}`,
		borderRadius: 4,
		padding: 16
	},
	checked: {
		border: `1px solid ${theme.palette.primary.main}`
	},
	content: {
		marginTop: 16,
		padding: 16
	}
}));

export interface RadioWithContentProps {
	checked: boolean;
	disabled?: boolean;
	onChange: () => void;
	label: string;
	content: JSX.Element;
}

export const RadioWithContent = (props: RadioWithContentProps) => {
	const { checked, disabled, onChange, label, content } = props;
	const classes = useStyles();

	return (
		<Box className={[classes.root, checked && classes.checked].filter(Boolean).join(' ')}>
			<Radio
				checked={checked}
				disabled={disabled}
				onChange={onChange}
				value="v"
				label={label}
			/>
			{
				checked && (
					<Paper className={classes.content}>
						{content}
					</Paper>
				)
			}
		</Box>
	);
};

export default RadioWithContent;
